export default __webpack_public_path__ + "static/media/FoxSeq_logo-1.c4b1bb85.png";